import { useState, useEffect } from 'react'

const String = ({contentTypeId, contentSetting, contentValue, setIsDraft, setLastSaved}) => {
    const[cValue, setCValue] = useState(contentValue)
    const [val, setVal] = useState('')

    useEffect(() => {
        const getValue = (contentSetting, cValue) => {
            if(cValue){
                if(cValue.contentDraft !== ""){
                    setVal(cValue.contentDraft)
                    setIsDraft(true)
                }else if(cValue.contentPublished !== ""){
                    setVal(cValue.contentPublished)
                }
            }else{
                setVal(contentSetting.defaultValue)
                setIsDraft(true)
            }
        }
        getValue(contentSetting, cValue)
    },[])

    const updateValue = async () => {
        var data = JSON.stringify( {
            value: val
            ,settingId: contentSetting.id
            ,settingAlias: contentSetting.settingAlias
        })
        const res = await fetch(`${global.config.Api.url}${global.config.Editor.publicToken}/ContentType/${contentTypeId}/values${cValue ? `/${cValue.id}` : ''}`,{
            method:(cValue ? 'PUT' : 'POST'),
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: data
        })
        if(!cValue){
            const response = await res.json()
            setCValue(response)
        }
        setLastSaved(new Date())
    }

    const handleBlur = async e => {
        e.preventDefault()
        await updateValue()
        setIsDraft(true)
    }

    return (
        <div className="cc_value_list_item_content">
            <input type="text" value={val} onChange={e => setVal(e.target.value)} onBlur={handleBlur}/>
        </div>
    )
}

export default String
